export const migrate_theme = {
  error_unknown: 'Something is wrong, an unexpected error has occurred.',
  migrate_error: 'Migrate failed',
  migrate_success: 'Migrate successful',
  migrating: 'Migrating',
} as const;
